import { https , httpsFile } from './http.js' ;

export function index (page,currentpage,search) {
    return https().get( `/approval_maintenance?page=${page}&currentpage=${currentpage}&search=${search}` )
}
export function getApprovalGrps () {
    return https().get( `/getApprovalGrps` )
}

export function create ( formdata ) {
    return httpsFile().post( '/approval_maintenance' , formdata )
}

export function updateApprGrp ( formdata ) {
    return httpsFile().post( '/updateApprGrp' , formdata )
}
export function deleteApprovalApproverAssignment ( id ) {
    return httpsFile().get( '/deleteApprovalApproverAssignment?appr_grp_approver_id=' + id )
}